



























































const namespace = 'calendar';
import { Vue, Prop, Component } from 'vue-property-decorator';
import SingleLocation from '@/modules/calendar/components/locations/SingleLocation.vue';
import { ICountLocationsAndEvents } from '@/modules/calendar/interfaces/ICountLocationsAndEvents';
import { WeekDaysEvents } from '@/modules/calendar/store/types';
import { getWeekDayName } from '@/utils/weekDays';
import { Getter } from 'vuex-class';

@Component({
    name: 'CalendarDay',
    components: {
        SingleLocation,
    },
})
export default class CalendarDays extends Vue {
    @Prop() private range!: number[];
    @Prop() private countLocationsAndEvents!: ICountLocationsAndEvents;
    @Prop() private boxType!: string;
    @Prop() private customBoxWidth!: string;
    @Getter('isMobile', { namespace }) private isMobile!: number;
    @Getter('weekdayContainerWidth', { namespace }) private weekdayContainerWidth!: number;
    @Getter('weekdaysContainerWidth', { namespace }) private weekdaysContainerWidth!: number;
    @Getter('eventsByWeekDays', { namespace }) private eventsByWeekDays!: WeekDaysEvents[];

    private opened = [0];

    private get isApple() {
        const applePlatforms = ['Mac68K', 'MacPPC', 'MacIntel', 'iPhone', 'iPod', 'iPad'];
        return applePlatforms.includes(navigator.platform);
    }

    private get mobileView() {
        return this.isMobile;
    }

    private get headersContainerWidth() {
        return this.weekdaysContainerWidth;
    }

    private get daysContainerWidth() {
        return this.isMobile ? '' : this.headersContainerWidth;
    }

    private get weekdayWidth() {
        return this.weekdayContainerWidth;
    }

    public get getEventsByWeekDays() {
        return this.eventsByWeekDays;
    }

    private get getHoursRange() {
        return this.range;
    }

    private get getCountLocationsAndEvents() {
        return this.countLocationsAndEvents;
    }

    private get getBoxType() {
        return this.boxType;
    }

    private get getCustomBoxWidth() {
        if (this.isMobile) {
            return `width: 100%`;
        }

        const width =
            this.getBoxType !== 'small' ? `width: ${100 / this.getCountLocationsAndEvents.countEvents}%;` : '';
        return width;
    }

    public weekDayName(weekDayId: number): string {
        return getWeekDayName(weekDayId);
    }

    public getIsMobile() {
        return this.isMobile;
    }
}
